// tslint:disable
export var ExtauthValidationType;
(function (ExtauthValidationType) {
    // UserName only
    ExtauthValidationType[ExtauthValidationType["UserName"] = 0] = "UserName";
    // UserName and Password combo
    ExtauthValidationType[ExtauthValidationType["Password"] = 1] = "Password";
    // Security Question and Answer
    ExtauthValidationType[ExtauthValidationType["KnowledgeBase"] = 2] = "KnowledgeBase";
})(ExtauthValidationType || (ExtauthValidationType = {}));
ExtauthValidationType['USERNAME'] = 0;
ExtauthValidationType['PASSWORD'] = 1;
ExtauthValidationType['KNOWLEDGEBASE'] = 2;
//# sourceMappingURL=ExtauthValidationType.js.map